(function(angular){
	'use strict';
	
	angular.module('scrollDownPromptModule', [
		'BaseConfig',
		'smoothScroll'
	]);

})(window.angular);